export function processVisitModal() {
    $(document).ready(function () {
        setTimeout(() => {
            if (!Boolean(sessionStorage.getItem('visitModalWasShown'))) {
                $('.visit-modal').fadeIn();

                $('.visit-modal__close-button, .visit-modal__link-button').click(function () {
                    $('.visit-modal').fadeOut();
                    sessionStorage.setItem('visitModalWasShown', 'true');
                });
            }
        }, 1250);
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/visit-modal.js